import React, { useRef } from "react";
import style from "./AddBeneficiaryMinDetails.module.css";
import {
    Box,
    Button,
    ChakraProvider,
    FormControl,
    FormLabel,
    Image,
    Input,
    Stack,
    Text,
    extendTheme,
    InputGroup,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    useDisclosure,
    Switch
} from "@chakra-ui/react";
import PhoneInput from 'react-phone-input-2';
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAddress, updateUserMobileNo } from "./Action/updateAddress";
import { CreatePayload, createBeneficiaries } from "./Action/createBenficiaries";
import { benRouting } from "./Action/benRouting";
import { BenDataProps } from "../../Helper/BenInterface";
import { getAllBen } from "../Landing/Otp/Action/getAllBen";
import 'react-phone-input-2/lib/material.css'
import { ShowAlert } from "../../GlobalComponents/ShowAlert/ShowAlert";
import { updatePersonalInfo } from "../BeneficiaryDetails/Actions/beneficiaryDetails.action";
import { createAddress } from "./Action/createAddress";
import { wordpressBaseUrl } from "../../wordpressApiConfig/wordpressApiConfig";
import Navbar from "../../GlobalComponents/Navbar/Navbar";
// import { set } from "react-ga";

const activeLabelStyles = {
    transform: "scale(0.85) translateY(-28px)",
    backgroundColor: "white",
    color: "#008470",
    fontWeight: "bold",
};
export const theme = extendTheme({
    components: {
        Form: {
            variants: {
                floating: {
                    container: {
                        _focusWithin: {
                            label: {
                                ...activeLabelStyles,
                            },
                        },
                        "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label":
                        {
                            ...activeLabelStyles,
                        },
                        label: {
                            top: 2,
                            left: 0,
                            zIndex: 2,
                            position: "absolute",
                            color: "#6F6F6F",
                            fontSize: "16px",

                            pointerEvents: "none",
                            mx: 3,
                            px: 1,
                            my: 2,
                            transformOrigin: "left top",
                        },
                    },
                },
            },
        },
    },
});
interface SubscriberData {
    subscriber: BenDataProps
}

const AddBeneficiaryMinDetails: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [isButtonDisabled, setButtonDisabled] = useState(true);
    const subscriberData = useSelector((state: SubscriberData) => state.subscriber);
    const userData = useSelector(((state: any) => state.user))
    const benData = useSelector((state: any) => state.beneficiary);
    const [beneficiariesList, setBeneficiariesList] = useState<any[]>([]);
    const wpBaseUrl = wordpressBaseUrl();
    const [sameWhatsapp, setSameWhatsapp] = useState<any>({});
    const componentMount=useRef(true)

    function checkIfAnyDataAdded(beneficiariesList: any) {
        let result = false;
        for (let i = 0; i < beneficiariesList.length; i++) {
            
            const whatsappNumber = beneficiariesList[i].whatsappMobile?.number;
           
            // Only validate WhatsApp if it has a valid number (not null, undefined, 0, or empty string)
            const hasWhatsappValidationError = whatsappNumber && 
                whatsappNumber.toString() !== "0" && 
                whatsappNumber.toString() !== "" && 
                whatsappNumber.toString().length !== 10;
            
            if (
                beneficiariesList[i].mobile?.number?.toString().length !== 10 ||
                beneficiariesList[i].pinCode?.toString().length !== 6 ||
                beneficiariesList[i].city?.length < 3 ||
                hasWhatsappValidationError
            ) {
                // console.log("inside else condition",beneficiariesList[i])
                result = true;
                // break;
            }
        }
        setButtonDisabled(result);
    }
    // console.log('beneficiariesList:', beneficiariesList);
    const handleSubmit = async () => {
        
        //so here i have all the details from the
        // beneficiariesList---first element is sub so i need to update using that benId
        //all other i need to create ben calling the create ben api that is if both of them successful need to redirect home 
        // if suppose ben_creation failed what should i do??
        //if sub updating failed what should i do??
        setLoading(true)
        if (beneficiariesList[0]?._id) {
           
            if (beneficiariesList[0].relationshipToSubscriber === 'Self' && userData.mobileNo === 'undefined-undefined') {
                try {

                    await updateUserMobileNo(userData.userId, {
                        mobileNo: {
                            countryCode: Number(beneficiariesList[0]?.mobile?.countryCode),
                            number: Number(beneficiariesList[0]?.mobile?.number)
                        },
                        companyId: subscriberData.company?.id
                    })
                } catch (error: any) {
                    if (error.response.status === 409) {
                        let newAllBenData = [...beneficiariesList];
                        newAllBenData[0].mobile.number = "";
                        setBeneficiariesList(newAllBenData);
                        ShowAlert("warning", "Self beneficiary number is already exist!")
                        setLoading(false)
                        return
                    }
                }
            }

            await updateIncompletedData(beneficiariesList)
        } else {
            try {
                const duplicationData: any = [...beneficiariesList];
              
                //if benId is present need to update//
                
                const subData = duplicationData.shift();
             
                
                const subAddress = {
                    address: {
                        ...(subscriberData?.address[0]?._id && { _id: subscriberData.address[0]?._id }),
                        city: subData.city,
                        pinCode: Number(subData.pinCode)
                    }
                }
                // console.log(subData?.whatsappNumber?.countryCode,"subdata?.whatsappNumber?.countryCode")

                const newBenData: CreatePayload = {
                    data: duplicationData.map((item: any) => {
                        if (item.whatsappMobile?.number == null || item.whatsappMobile?.number === "") {
                            const { whatsappMobile, ...rest } = item; // strip out whatsappMobile
                            return rest;
                        }
                        return item;
                    }),
                    subscriberId: {
                        ID: subscriberData.subscriberId
                    }
                };



                const whatsappNumber = subData?.whatsappMobile?.number?.toString();
                const isValidWhatsapp = whatsappNumber && whatsappNumber.length === 10;
                
                const benPayload: any = {
                    mobile: {
                        number: Number(subData?.mobile?.number),
                        countryCode: Number(subData?.mobile?.countryCode)
                    },
                    whatsappMobile: {
                        countryCode: 91,
                        number: isValidWhatsapp ? Number(subData?.whatsappMobile?.number) : null
                    }
                };

                if (userData.mobileNo === 'undefined-undefined') {
                    try {

                        await updateUserMobileNo(userData.userId, {
                            mobileNo: {
                                countryCode: Number(subData?.mobile?.countryCode),
                                number: Number(subData?.mobile?.number)
                            },
                            companyId: subscriberData.company?.id
                        })
                    } catch (error: any) {
                        if (error.response.status === 409) {
                            let newAllBenData = [...beneficiariesList];
                            newAllBenData[0].mobile.number = "";
                            setBeneficiariesList(newAllBenData);
                            ShowAlert("warning", "Self beneficiary number is already exist!")
                            setLoading(false)
                            return
                        }
                    }
                }
                
                await updatePersonalInfo(benData[0]?._id, benPayload);
                subscriberData?.address[0]?._id ? await updateAddress(subData.id, subAddress.address) : await createAddress(subData.id, subAddress.address);
                await createBeneficiaries(newBenData, dispatch)
                await getAllBen(subscriberData.subscriberId, dispatch)
                ShowAlert("success", "Beneficiary details updated Successfully");
                setLoading(false)
                onOpen();
            } catch (error: any) {
                console.log(error)
                error.response?.data?.message ? ShowAlert('warning', error.response?.data?.message) :
                    ShowAlert('warning', "Please try again later!")
                setLoading(false)
            }
        }

    };
    const handleSameWhatsapp = (id: string) => {
        setSameWhatsapp((prev: any) => {
            const newState = {
                ...prev,
                [id]: !prev[id]
            };
            
            // Update WhatsApp number when toggle is switched on
            if (newState[id]) {
                setBeneficiariesList((prevList) => 
                    prevList.map((ben) => 
                        (ben.toggleId === id || ben._id === id)
                            ? { ...ben, whatsappMobile: { ...ben.mobile } }
                            : ben
                    )
                );
            }
            
            return newState;
        });
    };

    const updateIncompletedData = async (benData: any) => {
        // console.log('benData:', benData);
        // console.log("benData:", benData);
     
        for (const el of benData) {
        
            const whatsappNumber = el.whatsappMobile?.number?.toString();
            const isValidWhatsapp = whatsappNumber && whatsappNumber.length === 10;
            
            const benPayload = {
                fullName: el.fullName,
                mobile: el.mobile,
                whatsappMobile: {
                    countryCode: 91,
                    number: isValidWhatsapp ? el.whatsappMobile.number : null
                },
                relationToSubscriber: el.relationshipToSubscriber
            };
            const addresPayload = {
                ...(el.addressId && { _id: el.addressId }),
                city: el.city,
                pinCode: el.pinCode
            }
         
            await updatePersonalInfo(el._id, benPayload);
            addresPayload?._id ? await updateAddress(el._id, addresPayload) : await createAddress(el._id, addresPayload);


        }
        onOpen();
    }
    useEffect(() => {
        
        if (!benData.length) {
            window.location.href = `${wpBaseUrl}/home/`; 
            // return navigate("/")
        }

        benRouting(subscriberData.subscriberId, navigate)
        const localStorageData = localStorage.getItem("beneficiariesData");
        if (localStorageData) {
            const parsedData = JSON.parse(localStorageData);
            // console.log(parsedData,"parsedData")
           
            // Initialize WhatsApp numbers on first load
            const updatedData = parsedData.map((elem: any, index: number) => {
                let updatedElem = { ...elem };
                // console.log(elem,"elem")
                
                // Add toggleId for WhatsApp toggle functionality
                updatedElem.toggleId = elem._id || `temp_${index}_${Date.now()}`;
                // console.log(elem.whatsappMobile?.number,"elem.whatsappMobile?.number")

                if (updatedElem.whatsappMobile?.number) {
                    updatedElem.whatsappMobile = { ...updatedElem.whatsappMobile };
                }
                
                return updatedElem;
            });
            
            updatedData.forEach((elem:any)=>{
                const toggleKey = elem?.toggleId || elem?._id;
                // console.log(elem?.mobile?.number,"elem?.mobile?.number",elem?.whatsappMobile?.number,"elem?.whatsappMobile?.number")
                if((Number(elem?.mobile?.number) !== Number(elem?.whatsappMobile?.number))&&elem?.whatsappMobile?.number&&elem?.mobile?.number){
                    setSameWhatsapp((prev: any) => ({
                        ...prev,
                        [toggleKey]: false
                    }));
                }else if(!elem?.whatsappMobile?.number&&elem?.mobile?.number){
                    setSameWhatsapp((prev: any) => ({
                        ...prev,
                        [toggleKey]: false
                    }));
                }
                else{
                    setSameWhatsapp((prev: any) => ({
                        ...prev,
                        [toggleKey]: true
                    }));    
                }
            })
            setBeneficiariesList(updatedData);
        }
        componentMount.current = false;
        //eslint-disable-next-line
    }, []);

    return (
        <>
            <ChakraProvider theme={theme}>
                <Navbar />
                <Box className={style.benBasicDetail_wrapper} mt={{ base: "4.25rem", md: "5rem" }}>
                    <Box className={style.benBasicDetail_container}>
                        <Box className={style.benBasicDetail_Section}>
                            <Box className={style.ben_banner_image}>
                                <Image src="/Images/pococare_login.jpg" alt="banner_Image" />
                            </Box>
                            <Box>
                                <Box>
                                    <Text className={style.heading}>
                                        Let us know more about your beneficiaries
                                    </Text>
                                </Box>

                                <Box className={style.benMinDetail}>
                                    {beneficiariesList?.map((el, i) => {
                                        return (

                                            <Box className={style.benAddForm} key={i}>
                                                <Box mb={"10px"}>
                                                    <Text>Name:{el.fullName}</Text>
                                                    <Text>{el.relationToSubscriber || el.relationshipToSubscriber}</Text>
                                                </Box>

                                                <Stack spacing={"10px"}>
                                                    <FormControl>
                                                        <InputGroup>
                                                            <PhoneInput
                                                                inputStyle={{ height: '55px' }}
                                                                onlyCountries={["in"]}
                                                                country="in"
                                                                autoFormat={true}
                                                                disableCountryCode={true}
                                                                placeholder="Phone Number"
                                                                value={`${el?.mobile?.number}`}
                                                                onChange={(
                                                                    value: string
                                                                ) => {
                                                                    
                                                                    let updatedEl = {
                                                                        ...el,
                                                                        mobile: {
                                                                            countryCode: 91,
                                                                            number: Number(value),
                                                                        }
                                                                    };
                                                                    let newBenList;
                                                               
                                                                     
                                                                    if(sameWhatsapp[el?.toggleId || el?._id]){                                                               
                                                                        updatedEl={
                                                                            ...updatedEl,
                                                                            whatsappMobile: {
                                                                                countryCode: 91,
                                                                                number: Number(value),
                                                                            }
                                                                        }

                                                                    }
                                                                    
                                                                    setBeneficiariesList((prev) => {
                                                                        const newList = [...prev];
                                                                        newList[i] = updatedEl;
                                                                        newBenList = newList
                                                                        return newList
                                                                    })
                                                                    checkIfAnyDataAdded(newBenList);
                                                                }}
                                                            />
                                                        </InputGroup>
                                                        {el.mobile?.number?.toString().length !== 10 && (
                                                            <Text color="red" fontSize="sm">
                                                                Mobile should be 10 digits
                                                            </Text>
                                                        )}
                                                    </FormControl>
                                                    <FormControl
                                                        isDisabled={userData.userRole === "BENEFICIARY"}
                                                        marginBottom={"15px"}
                                                        marginTop={"15px"}
                                                        gap="20px"
                                                        display="flex"
                                                        alignItems="center"
                                                    >
                                                        <Switch
                                                            onChange={() => handleSameWhatsapp(el?.toggleId || el?._id)}
                                                            isChecked={sameWhatsapp?.[el?.toggleId || el?._id]}
                                                            id="same-whatsappNumber"
                                                        />
                                                        {
                                                            sameWhatsapp?.[el?.toggleId || el?._id] ? (<FormLabel color={"#1C2B2F"} htmlFor="same-whatsappNumber" mb="0">
                                                                WhatsApp number is same as mobile number
                                                            </FormLabel>) : (<FormLabel color={"#1C2B2F"} htmlFor="same-whatsappNumber" mb="0">
                                                                WhatsApp number is not same as mobile number
                                                            </FormLabel>)
                                                        }
                                                    </FormControl>

                                                      <FormControl>
                                                         <PhoneInput
                                                        //@ts-ignore
                                                        inputStyle={{ height: '55px' }}
                                                        disabled={sameWhatsapp?.[el?.toggleId || el?._id]}
                                                        country="in"
                                                        onlyCountries={["in"]}
                                                        autoFormat={true}
                                                        disableCountryCode={true}
                                                        containerStyle={{
                                                            position: 'relative'
                                                        }}
                                                        inputProps={{
                                                            'data-label': 'WhatsApp Number'
                                                        }}
                                                        value={
                                                            el?.whatsappMobile?.number != null && el?.whatsappMobile?.number !== 0
                                                                ? String(el?.whatsappMobile?.number) 
                                                                : ""
                                                        }
                                                        //@ts-ignore
                                                        name="Whatsapp Number"
                                                        placeholder="WhatsApp Number"
                                                        onChange={(
                                                                    value: string
                                                                ) => {
                                                                    // Handle empty or cleared field
                                                                    const numberValue = value === "" || value === "91" ? null : Number(value);
                                                                    
                                                                    const updatedEl = {
                                                                        ...el,
                                                                        whatsappMobile: {
                                                                            countryCode: 91,
                                                                            number: numberValue,
                                                                        }
                                                                    };
                                                                    let newBenList;
                                                                    setBeneficiariesList((prev) => {
                                                                        const newList = [...prev];
                                                                        newList[i] = updatedEl;
                                                                        newBenList = newList
                                                                        return newList
                                                                    })
                                                                    checkIfAnyDataAdded(newBenList);
                                                                }}
                                                    />
                                                        {el.whatsappMobile?.number && 
                                                         el.whatsappMobile?.number.toString() !== "0" && 
                                                         el.whatsappMobile?.number.toString().length !== 10 && (
                                                            <Text color="red" fontSize="sm">
                                                                WhatsApp number should be 10 digits
                                                            </Text>
                                                        )}
                                                        <Text color="black" fontSize="sm">
                                                           whatsapp number is optional
                                                        </Text>
                                                      </FormControl>
                                                    <FormControl variant="floating" id="name">
                                                        <Input
                                                            boxShadow="white"
                                                            _hover={{ borderColor: "white" }}
                                                            _focus={{ borderColor: "green.100" }}
                                                            fontSize={"18px"}
                                                            name={"city"}
                                                            height={"55px"}
                                                            type="text"
                                                            value={el.city}
                                                            onChange={(e) => {
                                                                let cityWithOnlyChars = e.target.value.replace(/[^A-Za-z]/g, '');
                                                                let newBen = [...beneficiariesList];
                                                                newBen[el.index].city = cityWithOnlyChars;
                                                                setBeneficiariesList(newBen);
                                                                checkIfAnyDataAdded(newBen);
                                                            }}
                                                            bg="white"
                                                            placeholder=" "
                                                        />
                                                        <FormLabel>City</FormLabel>
                                                        {el.city?.length < 3 && (
                                                            <Text color="red" fontSize="sm">
                                                                {/* City should have at least 3 characters */}
                                                                City is mandatory
                                                            </Text>
                                                        )}
                                                    </FormControl>
                                                    <FormControl variant="floating" id="name">
                                                        <Input
                                                            boxShadow="white"
                                                            _hover={{ borderColor: "white" }}
                                                            _focus={{ borderColor: "green.100" }}
                                                            fontSize={"18px"}
                                                            name={"pinCode"}
                                                            height={"55px"}
                                                            type="number"
                                                            value={"" + el.pinCode}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 6) {

                                                                    let newBen = [...beneficiariesList];
                                                                    newBen[el.index].pinCode = Number(e.target.value);
                                                                    setBeneficiariesList(newBen);
                                                                    checkIfAnyDataAdded(newBen);
                                                                }
                                                            }}
                                                            bg="white"
                                                            placeholder=" "
                                                        />
                                                        <FormLabel>PinCode</FormLabel>
                                                        {el.pinCode?.toString().length !== 6 && (
                                                            <Text color="red" fontSize="sm">
                                                                Pin code should be 6 digits
                                                            </Text>
                                                        )}
                                                    </FormControl>
                                                </Stack>
                                            </Box>
                                        );
                                    })}
                                </Box>
                                <Button
                                    w={"40%"}
                                    mt={"15px"}
                                    borderRadius={"46px"}
                                    bg={"#008470"}
                                    color={"white"}
                                    onClick={handleSubmit}
                                    isDisabled={isButtonDisabled}
                                    _hover={{
                                        bg: "#008470",
                                    }}
                                    isLoading={loading}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    {/* <Button isDisabled={true}>hello</Button> */}
                </Box>
            </ChakraProvider>

            {/* Download app modal */}

            <Modal isOpen={isOpen} onClose={() => {
                navigate("/dashboard")
                onClose()
            }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Congratulations!</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        Congratulations! Your Profile has been activated successfully.
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            colorScheme='blue'
                            mr={3}
                            onClick={() => {
                                window.open("https://play.google.com/store/apps/details?id=com.pococare.pocoemurgency&hl=en_IN", "_blank");
                                navigate("/dashboard");
                                onClose();
                            }}>
                            Download App
                        </Button>
                        <Button variant='ghost' onClick={() => navigate("/dashboard")}>OK</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AddBeneficiaryMinDetails;
